module.exports = __webpack_public_path__ + "static/media/ArrowUp.a9b0e853.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ArrowUp.svg
// module id = 1044
// module chunks = 0